import { I18nContext } from 'contexts/I18n/I18nProvider'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Bar, CartesianGrid, ComposedChart, Line, Tooltip, XAxis, YAxis } from 'recharts'
import { MappedWifiEvents } from '../../../redux/types'
import { getData } from './setup'

type GraphicProps = {
  events: MappedWifiEvents
}

type CustomTooltipProps = {
  active: boolean
  payload: Array<any>
}

function CustomTooltip({ active, payload }: CustomTooltipProps) {
  const t = useContext(I18nContext)
  if (active && payload?.length && payload[1].value) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${t('wifi_dashboards.bandwidth')}: ${payload[1].value}GHz`}</p>
        <p className="label">{`${t('wifi_dashboards.channel_number')}: ${payload[0].value}`}</p>
      </div>
    )
  }
  return null;
}

export default function Graphic({ events }: GraphicProps) {
  const t = useContext(I18nContext)
  const bandwidthLegend = t('wifi_dashboards.bandwidth')
  const channelNumberLegend = t('wifi_dashboards.channel_number')
  const ref = useRef<HTMLHeadingElement>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    setWidth(ref.current ? ref.current.offsetWidth : 0)
  }, [ref.current])

  return (
    <div ref={ref}>
      <ComposedChart
        width={width}
        height={300}
        data={getData(events, bandwidthLegend, channelNumberLegend)}
        margin={{
          top: 5,
          right: 30,
          left: -20,
          bottom: 5,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis dataKey="name" scale="point" />
        <YAxis domain={[0, 5]} />
        <Tooltip content={(content) => <CustomTooltip active={content.active || false} payload={content.payload || []} />} offset={-65} />
        <Bar dataKey={channelNumberLegend} barSize={20} fill="#cccccc" />
        <Line type="linear" dataKey={bandwidthLegend} stroke="#e60000" dot={false} activeDot={{ r: 8 }} strokeWidth={2} />
      </ComposedChart>
    </div>
  )
}
